import React, { lazy, Suspense } from 'react'
import { ConnectedRouter } from 'connected-react-router'
import { connect } from 'react-redux'
import { Redirect, Route, Switch } from 'react-router-dom'
import { CSSTransition, SwitchTransition } from 'react-transition-group'

import Layout from 'layouts'

const routes = [
  // Início
  {
    path: '/overview/',
    Component: lazy(() => import('pages/overview')),
    exact: true,
  },
  // Acadêmico
  // Turmas
  {
    path: '/classes/',
    Component: lazy(() => import('pages/classes/overview')),
    exact: true,
  },
  {
    path: '/classes/:classId/',
    Component: lazy(() => import('pages/classes/class')),
    exact: false,
  },
  // Questões
  {
    path: '/questions/',
    Component: lazy(() => import('pages/questions')),
    exact: true,
  },
  {
    path: '/questions/:questionId/',
    Component: lazy(() => import('pages/questions/question')),
    exact: false,
  },
  // Professores
  {
    path: '/teachers/',
    Component: lazy(() => import('pages/teachers')),
    exact: true,
  },
  // Corretores
  {
    path: '/teachers-essays/',
    Component: lazy(() => import('pages/teachers-essays')),
    exact: true,
  },
  // Estatísticas
  {
    path: '/statistics/',
    Component: lazy(() => import('pages/statistics/overview')),
    exact: true,
  },
  // Ligas
  {
    path: '/leagues/',
    Component: lazy(() => import('pages/leagues')),
    exact: true,
  },
  {
    path: '/leagues/create',
    Component: lazy(() => import('pages/leagues/create')),
    exact: true,
  },
  {
    path: '/leagues/:id/edit',
    Component: lazy(() => import('pages/leagues/edit')),
    exact: true,
  },
  {
    path: '/leagues/:id',
    Component: lazy(() => import('pages/leagues/view')),
    exact: true,
  },
  // Configurações
  {
    path: '/configs/disciplines',
    Component: lazy(() => import('pages/configs/disciplines')),
    exact: true,
  },
  {
    path: '/configs/disciplines/create',
    Component: lazy(() => import('pages/configs/disciplines/create')),
    exact: true,
  },
  {
    path: '/configs/disciplines/:disciplineId',
    Component: lazy(() => import('pages/configs/disciplines/view')),
    exact: true,
  },
  {
    path: '/configs/disciplines/:disciplineId/edit',
    Component: lazy(() => import('pages/configs/disciplines/edit')),
    exact: true,
  },
  // Turmas
  {
    path: '/configs/groups',
    Component: lazy(() => import('pages/configs/groups')),
    exact: true,
  },
  {
    path: '/configs/groups/create',
    Component: lazy(() => import('pages/configs/groups/create')),
    exact: true,
  },
  {
    path: '/configs/groups/import',
    Component: lazy(() => import('pages/configs/groups/import')),
    exact: true,
  },
  {
    path: '/configs/groups/bulk-edit',
    Component: lazy(() => import('pages/configs/groups/bulk-edit')),
    exact: true,
  },
  {
    path: '/configs/groups/:groupId/edit',
    Component: lazy(() => import('pages/configs/groups/edit')),
    exact: true,
  },
  // Webhooks
  {
    path: '/admin/webhooks/',
    Component: lazy(() => import('pages/admin/webhooks')),
    exact: true,
  },
  // Comunicação
  // Comunicados
  {
    path: '/notifications/',
    Component: lazy(() => import('pages/notifications')),
    exact: true,
  },
  {
    path: '/notifications/create',
    Component: lazy(() => import('pages/notifications/create')),
    exact: true,
  },
  // Mensagens
  {
    path: '/messages/',
    Component: lazy(() => import('pages/messages')),
    exact: true,
  },
  {
    path: '/messages/create',
    Component: lazy(() => import('pages/messages/create')),
    exact: true,
  },
  {
    path: '/messages/dry-run',
    Component: lazy(() => import('pages/messages/dry-run')),
    exact: true,
  },
  // Conversas
  {
    path: '/messages/conversations/',
    Component: lazy(() => import('pages/messages/conversations')),
    exact: true,
  },
  {
    path: '/messages/conversation',
    Component: lazy(() => import('pages/messages/conversation')),
    exact: true,
  },
  // Solicitações
  {
    path: '/solicitations/',
    Component: lazy(() => import('pages/solicitations')),
    exact: true,
  },
  // Simulados
  {
    path: '/exams/',
    Component: lazy(() => import('pages/exams')),
    exact: true,
  },
  {
    path: '/exams/create/',
    Component: lazy(() => import('pages/exams/create')),
    exact: true,
  },
  {
    path: '/exams/questions/',
    Component: lazy(() => import('pages/exams/questions')),
    exact: true,
  },
  {
    path: '/exams/statistics/',
    Component: lazy(() => import('pages/exams/statistics')),
    exact: true,
  },
  {
    path: '/exams/questions/create/',
    Component: lazy(() => import('pages/exams/questions/create')),
    exact: true,
  },
  {
    path: '/exams/questions/:questionId/',
    Component: lazy(() => import('pages/exams/questions/view')),
    exact: false,
  },
  {
    path: '/exams/:examId/',
    Component: lazy(() => import('pages/exams/view')),
    exact: false,
  },
  // Listas de Exercícios
  {
    path: '/quizzes/',
    Component: lazy(() => import('pages/quizzes')),
    exact: true,
  },
  {
    path: '/quizzes/create/',
    Component: lazy(() => import('pages/quizzes/create')),
    exact: true,
  },
  {
    path: '/quizzes/:quizId/',
    Component: lazy(() => import('pages/quizzes/view')),
    exact: false,
  },
  // Monitorias
  {
    path: '/bookings/',
    Component: lazy(() => import('pages/bookings/room')),
    exact: true,
  },
  {
    path: '/bookings/availabilities/',
    Component: lazy(() => import('pages/bookings/availabilities')),
    exact: true,
  },
  {
    path: '/bookings/create/',
    Component: lazy(() => import('pages/bookings/room/create')),
    exact: true,
  },
  {
    path: '/bookings/statistics/',
    Component: lazy(() => import('pages/bookings/statistics')),
    exact: true,
  },
  {
    path: '/bookings/configs/',
    Component: lazy(() => import('pages/bookings/configs')),
    exact: true,
  },
  {
    path: '/bookings/blocks/',
    Component: lazy(() => import('pages/bookings/availability-blocks')),
    exact: true,
  },
  {
    path: '/bookings/:bookingId/',
    Component: lazy(() => import('pages/bookings/room/view')),
    exact: true,
  },
  {
    path: '/bookings/:bookingId/edit/',
    Component: lazy(() => import('pages/bookings/room/edit')),
    exact: true,
  },
  {
    path: '/bookings/credits/users/:userId',
    Component: lazy(() => import('pages/bookings/credits/users/user')),
    exact: true,
  },
  // Salas Físicas
  {
    path: '/physical-rooms/',
    Component: lazy(() => import('pages/physical-rooms')),
    exact: true,
  },
  {
    path: '/physical-rooms/create/',
    Component: lazy(() => import('pages/physical-rooms/create')),
    exact: true,
  },
  {
    path: '/physical-rooms/:physicalRoomId/edit/',
    Component: lazy(() => import('pages/physical-rooms/edit')),
    exact: true,
  },
  // Administração
  // Usuários
  {
    path: '/admin/users/',
    Component: lazy(() => import('pages/admin/users')),
    exact: true,
  },
  {
    path: '/admin/users/create/',
    Component: lazy(() => import('pages/admin/users/create')),
    exact: true,
  },
  {
    path: '/admin/users/import/',
    Component: lazy(() => import('pages/admin/users/import')),
    exact: true,
  },
  {
    path: '/admin/users/:userId/',
    Component: lazy(() => import('pages/admin/users/user')),
    exact: false,
  },
  // Contas de cobrança
  {
    path: '/admin/billing-accounts/',
    Component: lazy(() => import('pages/admin/billing-accounts')),
    exact: true,
  },
  {
    path: '/admin/billing-accounts/create/',
    Component: lazy(() => import('pages/admin/billing-accounts/create')),
    exact: true,
  },
  {
    path: '/admin/billing-accounts/:billingAccountId/edit/',
    Component: lazy(() => import('pages/admin/billing-accounts/edit')),
  },
  // Escolas
  {
    path: '/admin/schools/',
    Component: lazy(() => import('pages/admin/schools')),
    exact: true,
  },
  {
    path: '/admin/schools/create/',
    Component: lazy(() => import('pages/admin/schools/create')),
    exact: true,
  },
  {
    path: '/admin/schools/:schoolId/edit/',
    Component: lazy(() => import('pages/admin/schools/edit')),
    exact: true,
  },
  // Finance
  {
    path: '/finance/users',
    Component: lazy(() => import('pages/finance/users')),
    exact: false,
  },
  {
    path: '/finance/questions/',
    Component: lazy(() => import('pages/finance/questions')),
    exact: true,
  },
  {
    path: '/finance/questions/:questionId/',
    Component: lazy(() => import('pages/questions/question')),
    exact: false,
  },
  {
    path: '/finance/earnings-report/',
    Component: lazy(() => import('pages/finance/earnings-report')),
    exact: true,
  },
  // Reports
  {
    path: '/admin/reports/',
    Component: lazy(() => import('pages/admin/reports')),
    exact: true,
  },
  // Chaves de API
  {
    path: '/admin/api-keys/',
    Component: lazy(() => import('pages/admin/api-keys')),
    exact: true,
  },
  // Users
  {
    path: '/users/:userId',
    Component: lazy(() => import('pages/users/user')),
    exact: false,
  },
  // Auth Pages
  {
    path: '/auth/login',
    Component: lazy(() => import('pages/auth/login')),
    exact: true,
  },
  // Redeems a single-use login code
  {
    path: '/auth/handoff',
    Component: lazy(() => import('pages/auth/handoff')),
    exact: true,
  },
  {
    path: '/auth/forgot-password',
    Component: lazy(() => import('pages/auth/forgot-password')),
    exact: true,
  },
  {
    path: '/auth/register',
    Component: lazy(() => import('pages/auth/register')),
    exact: true,
  },
  {
    path: '/auth/lockscreen',
    Component: lazy(() => import('pages/auth/lockscreen')),
    exact: true,
  },
  {
    path: '/auth/404',
    Component: lazy(() => import('pages/auth/404')),
    exact: true,
  },
  {
    path: '/auth/500',
    Component: lazy(() => import('pages/auth/500')),
    exact: true,
  },
]

const mapStateToProps = ({ settings, user }) => ({
  routerAnimation: settings.routerAnimation,
  role: user.role,
})

function Router({ history, routerAnimation, role }) {
  return (
    <ConnectedRouter history={history}>
      <Layout>
        <Route
          render={state => {
            const { location } = state
            return (
              <SwitchTransition>
                <CSSTransition
                  key={location.pathname}
                  appear
                  classNames={routerAnimation}
                  timeout={routerAnimation === 'none' ? 0 : 300}
                >
                  <Switch location={location}>
                    <Route
                      exact
                      path="/"
                      render={() => (
                        <Redirect
                          to={
                            role === 'EXAMS_ONLY_GROUP_ADMIN' ? '/exams/statistics/' : '/overview/'
                          }
                        />
                      )}
                    />
                    {routes.map(({ path, Component, exact }) => (
                      <Route
                        path={path}
                        key={path}
                        exact={exact}
                        render={() => (
                          <div className={routerAnimation}>
                            <Suspense fallback={null}>
                              <Component />
                            </Suspense>
                          </div>
                        )}
                      />
                    ))}
                    <Redirect to="/auth/404" />
                  </Switch>
                </CSSTransition>
              </SwitchTransition>
            )
          }}
        />
      </Layout>
    </ConnectedRouter>
  )
}

export default connect(mapStateToProps)(Router)
